import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

const FooterCopyright = ({ footerLogo, spaceBottomClass, colorClass }) => {
  return (
    <div className={clsx('copyright', spaceBottomClass, colorClass)}>
      <div className='footer-logo'>
        <Link to={process.env.PUBLIC_URL + '/'}>
          <img src={footerLogo} alt='HeToko Logo' width='100' height='100' />
        </Link>
      </div>
      <p>
        &copy; {new Date().getFullYear()}{' '}
        <Link to={process.env.PUBLIC_URL + '/'}>HeToko</Link>
        .<br /> All Rights Reserved
      </p>
    </div>
  );
};

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string.isRequired,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
};

export default FooterCopyright;
